package com.bikompanion.ui.models

import com.bikompanion.domain.BikeVoteFailure

/** What the rate-a-bike flow has to tell the rider, as a fact rather than as copy. */
sealed interface BikeRatingMessage {
    data object NetworkRequired : BikeRatingMessage

    data class Thanks(
        val bikeNumber: String,
    ) : BikeRatingMessage

    data class InCooldown(
        val retryAfterMs: Long,
    ) : BikeRatingMessage {
        /** Never 0: "try again in 0 minutes" would read as "try again now", which it is not. */
        val retryAfterMinutes: Long get() = (retryAfterMs / 60_000).coerceAtLeast(1)
    }

    data object Queued : BikeRatingMessage

    data class Failed(
        val reason: BikeVoteFailure,
    ) : BikeRatingMessage
}
